import clsx from 'clsx';
import React from 'react';

import classes from './LeftColumn.module.scss';

interface LeftColumnProps {
    footer?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    contentClassName?: string;
    alignContentVertically?: boolean;
}

export const LeftColumn: React.FC<LeftColumnProps> = props => {
    return (
        <div className={clsx(classes.root, props.className)}>
            <div
                className={clsx('container', classes.content, props.contentClassName, {
                    'flex flex-col items-center justify-center': props.alignContentVertically
                })}
            >
                {props.children}
            </div>

            {props.footer && (
                <div className={classes.footer}>
                    <div className={clsx('container', classes.footerContent)}>{props.footer}</div>
                </div>
            )}
        </div>
    );
};
